exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".video-add-header{display:flex;justify-content:center;margin:30px auto;text-align:center}.video-add-header-inline{display:inline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/videos/components/VideoAdd/VideoAdd.scss
// module id = 362
// module chunks = 0